var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 2C7.38318 2 2 7.38318 2 14C2 16.2992 2.64566 18.5205 3.86717 20.4237L4.42377 21.291L4.04061 22.2476L2.89692 25.1031L5.75237 23.9594L6.70899 23.5762L7.57625 24.1328C9.47954 25.3543 11.7008 26 14 26C20.6168 26 26 20.6168 26 14C26 7.38318 20.6168 2 14 2ZM14 0C21.7192 0 28 6.28075 28 14C28 21.7192 21.7192 28 14 28C11.3085 28 8.72375 27.2457 6.496 25.816L1.2005 27.937C1.09375 27.979 0.985249 28 0.875 28C0.647499 28 0.4235 27.9107 0.25725 27.7445C0.00874901 27.496 -0.0665016 27.125 0.0629997 26.7995L2.184 21.504C0.75425 19.2762 0 16.6915 0 14C0 6.28075 6.28075 0 14 0Z",
    fill: "#01C6D9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 9V19",
    stroke: "#01C6D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 14H19",
    stroke: "#01C6D9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/new-chat.a2a3e710.svg";
export { ForwardRef as ReactComponent };